import {
  ALL_SPEAKERS_LIST,
  ALL_SPONSORS_LIST,
  ALL_EXHIBITORS_LIST,
  SEEN_EVENT_ADS
} from '../actions';

export function allSpeakers(state = {}, action) {
  switch (action.type) {
    case ALL_SPEAKERS_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function allSponsors(state = {}, action) {
  switch (action.type) {
    case ALL_SPONSORS_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function allExhibitors(state = {}, action) {
  switch (action.type) {
    case ALL_EXHIBITORS_LIST:
      return action.payload;
    default:
      return state;
  }
}

export const seenEventAds = (state = [], action) => {
  if (action.type == SEEN_EVENT_ADS) {
    return action.payload;
  }
  return state;
};
